export const getLayoutColumnCount = (numberOfElements, isMobile = false) => {
  return isMobile || numberOfElements < 5 ? 1 : 2;
};